'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _prop2 = require('ramda/src/prop');

var _prop3 = _interopRequireDefault(_prop2);

var _isNil2 = require('ramda/src/isNil');

var _isNil3 = _interopRequireDefault(_isNil2);

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _experiumPlayerHelpersLegacy = require('experium-player-helpers-legacy');

var _get_days_in_month = require('date-fns/get_days_in_month');

var _get_days_in_month2 = _interopRequireDefault(_get_days_in_month);

var _withFieldWrapper = require('../hocs/withFieldWrapper');

var _withFieldWrapper2 = _interopRequireDefault(_withFieldWrapper);

var _masks = require('../../constants/masks');

var _StyledDatePicker = require('./StyledDatePicker');

var _months = require('../../constants/months');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DatePickerComponent = function (_Component) {
    _inherits(DatePickerComponent, _Component);

    function DatePickerComponent(props) {
        _classCallCheck(this, DatePickerComponent);

        var _this = _possibleConstructorReturn(this, (DatePickerComponent.__proto__ || Object.getPrototypeOf(DatePickerComponent)).call(this, props));

        _initialiseProps.call(_this);

        var _ref = props.value || {},
            day = _ref.day,
            month = _ref.month,
            year = _ref.year;

        _this.state = {
            day: day,
            month: month,
            year: year
        };
        return _this;
    }

    _createClass(DatePickerComponent, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.onBlurDay();
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                disabled = _props.disabled,
                required = _props.required,
                _props$meta = _props.meta,
                submitFailed = _props$meta.submitFailed,
                error = _props$meta.error;
            var _state = this.state,
                day = _state.day,
                month = _state.month,
                year = _state.year;

            var showError = submitFailed && error;

            return _react2.default.createElement(
                _experiumPlayerHelpersLegacy.LanguageContext.Consumer,
                null,
                function (_ref2) {
                    var language = _ref2.language;
                    return _react2.default.createElement(
                        _StyledDatePicker.DatePickerContainer,
                        { errors: {
                                day: showError && !day,
                                month: showError && (0, _isNil3.default)(month),
                                year: showError && !year
                            } },
                        _react2.default.createElement(_StyledDatePicker.Input, {
                            value: day,
                            onChange: _this2.onChangeDay,
                            onBlur: _this2.onBlurDay,
                            mask: _masks.DAY_MASK,
                            placeholderChar: '\u2000',
                            keepCharPositions: false,
                            guide: true,
                            disabled: disabled,
                            placeholder: language === _experiumPlayerHelpersLegacy.RUS ? 'дд' : 'dd'
                        }),
                        _react2.default.createElement(_StyledDatePicker.DatePickerMonth, {
                            value: month,
                            placeholder: _react2.default.createElement(_experiumPlayerHelpersLegacy.FormattedMessage, { id: 'month' }),
                            searchable: false,
                            onChange: _this2.onChangeMonth,
                            clearable: !required,
                            disabled: disabled,
                            options: (0, _months.getMonthDictionary)(language) }),
                        _react2.default.createElement(_StyledDatePicker.Input, {
                            value: year,
                            mask: _masks.YEAR_MASK,
                            onChange: _this2.onChangeYear,
                            onBlur: _this2.onBlurYear,
                            placeholderChar: '\u2000',
                            keepCharPositions: false,
                            guide: true,
                            disabled: disabled,
                            placeholder: language === _experiumPlayerHelpersLegacy.RUS ? 'гггг' : 'yyyy'
                        })
                    );
                }
            );
        }
    }]);

    return DatePickerComponent;
}(_react.Component);

DatePickerComponent.propTypes = {
    value: _propTypes2.default.object,
    onChange: _propTypes2.default.func,
    disabled: _propTypes2.default.bool,
    required: _propTypes2.default.bool,
    meta: _propTypes2.default.object.isRequired
};
DatePickerComponent.defaultProps = {
    value: {}
};

var _initialiseProps = function _initialiseProps() {
    var _this3 = this;

    this.onChange = function (day, month, year) {
        _this3.props.onChange(!day && (0, _isNil3.default)(month) && !year ? null : { day: day, month: month, year: year });
    };

    this.onChangeDay = function (e) {
        var _state2 = _this3.state,
            month = _state2.month,
            year = _state2.year;
        var value = e.target.value;

        var day = +value ? +value : null;

        _this3.setState({ day: day });
        _this3.onChange(day, month, year);
    };

    this.onChangeMonth = function (props) {
        var month = (0, _prop3.default)('value', props);
        var _state3 = _this3.state,
            current = _state3.day,
            year = _state3.year;

        var day = month && (0, _get_days_in_month2.default)(new Date(year, month)) < current ? (0, _get_days_in_month2.default)(new Date(year, month)) : current;

        _this3.setState({ month: month, day: day });
        _this3.onChange(day, month, year);
    };

    this.onChangeYear = function (e) {
        var _state4 = _this3.state,
            day = _state4.day,
            month = _state4.month;
        var value = e.target.value;

        var year = +value ? +value : null;

        _this3.setState({ year: year });
        _this3.onChange(day, month, year);
    };

    this.onBlurDay = function () {
        var _state5 = _this3.state,
            current = _state5.day,
            month = _state5.month,
            year = _state5.year;

        var day = !month && current > 31 ? 31 : month && (0, _get_days_in_month2.default)(new Date(year, month)) < current ? (0, _get_days_in_month2.default)(new Date(year, month)) : current;

        _this3.setState({ day: day });
        _this3.onChange(day, month, year);
    };

    this.onBlurYear = function () {
        var _state6 = _this3.state,
            current = _state6.day,
            month = _state6.month,
            year = _state6.year;


        if (month && year) {
            var daysInMonth = (0, _get_days_in_month2.default)(new Date(year, month));

            if (daysInMonth < current) {
                _this3.setState({ day: daysInMonth });
                _this3.onChange(daysInMonth, month, year);
            }
        }
    };
};

exports.default = (0, _withFieldWrapper2.default)(DatePickerComponent);